export default {
  install(app) {
    app.config.globalProperties.agraConfiguration = window.Agra.Configuration
  }
}

